import React, { useState } from "react";
import { DataGrid, GridPaginationModel } from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import CustomPagination from "./CustomPagination";

// const CustomPagination = ({
//   totalPages,
//   currentPage,
//   onPageChange,
// }: {
//   totalPages: number;
//   currentPage: number;
//   onPageChange: (page: number) => void;
// }) => {
//   return (
//     <Box display="flex" alignItems="center" gap={1} mt={2}>
//       <Button
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={currentPage === 0}
//         className="page-btn"
//       >
//         &lt;
//       </Button>
//       {[...Array(totalPages)].map((_, idx) => (
//         <Button
//           key={idx}
//           variant={currentPage === idx ? "contained" : "outlined"}
//           onClick={() => onPageChange(idx)}
//           className={`page-btn ${currentPage === idx ? "active" : ""}`}
//           style={{
//             borderRadius: 8,
//             minWidth: 32,
//             padding: "6px 12px",
//             backgroundColor: currentPage === idx ? "#BC8F4B" : "#1f1f1f",
//             color: currentPage === idx ? "#fff" : "#ccc",
//           }}
//         >
//           {idx + 1}
//         </Button>
//       ))}
//       <Button
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={currentPage === totalPages - 1}
//         className="page-btn"
//       >
//         &gt;
//       </Button>
//     </Box>
//   );
// };

// const CustomPagination = ({
//   totalPages,
//   currentPage,
//   onPageChange,
// }: {
//   totalPages: number;
//   currentPage: number;
//   onPageChange: (page: number) => void;
// }) => {
//   const fixedPages = [0, 1, 2, 3]; // Static indexes: pages 1 to 4

//   return (
//     <Box display="flex" alignItems="center" gap={1} mt={2}>
//       <Button
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={currentPage === 0}
//         className="page-btn"
//       >
//         <img src="/static/images/pagination_arrow.svg" alt="icon" />
//       </Button>

//       <div className="count_page">
//         {fixedPages.map((pageIndex) => (
//           <Button
//             key={pageIndex}
//             variant={currentPage === pageIndex ? "contained" : "outlined"}
//             onClick={() => onPageChange(pageIndex)}
//             className={`page-btn ${currentPage === pageIndex ? "active" : ""}`}
//           >
//             {pageIndex + 1}
//           </Button>
//         ))}
//       </div>

//       <Button
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={currentPage === totalPages - 1}
//         className="page-btn"
//       >
//         <img src="/static/images/pagination_arrow.svg" alt="icon" />
//       </Button>
//     </Box>
//   );
// };

export default function TableComponent({ rows, columns }: any) {
  const pageSize = 10;
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize,
  });

  const totalPages = Math.ceil(rows.length / pageSize);
  const pagedRows = rows.slice(
    paginationModel.page * pageSize,
    (paginationModel.page + 1) * pageSize
  );

  const showEmptyMessage = rows.length === 0;

  return (
    <>
      {showEmptyMessage ? (
        <Box
          sx={{
            textAlign: "center",
            color: "#ccc",
            py: 5,
            backgroundColor: "#121212",
            borderRadius: 2,
          }}
        >
          No data found
        </Box>
      ) : (
        <>
          <DataGrid
            getRowId={(row) => (row._id ? row._id : row?.id)}
            rows={pagedRows}
            columns={columns}
            disableRowSelectionOnClick
            hideFooter
            rowHeight={65}
            localeText={{
              noRowsLabel: "No data found",
            }}
            sx={{
              backgroundColor: "#121212",
              color: "#fff",
              border: "none",
            }}
          />
          {/* Custom pagination or other UI can go here */}
        </>
      )}
    </>
  );
}
